import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/free-solid-svg-icons'
import { Backdrop } from 'src/global'
import {
  Modal,
  Header,
  CloseButtonWrapper,
  CloseButtonLineOne,
  CloseButtonLineTwo,
  ModalContent,
} from '../../../HomeScreen/ProductModal/styles'
import { TEST_MENUS, TestMenu, TestMenuSource } from './testMenus'
import { Group, GroupTitle, Row, Tag } from './styles'

type Props = {
  isOpen: boolean
  close: () => void
}

const GROUPS: { source: TestMenuSource; title: string }[] = [
  { source: 'prod-copy', title: 'Copii din producție' },
  { source: 'staging', title: 'Conturi de staging' },
]

export default function TestMenusModal({ isOpen, close }: Props) {
  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Modal style={{ width: '560px' }} className={isOpen ? 'open' : 'closed'}>
        <Header>
          Meniuri de test
          <CloseButtonWrapper onClick={close} title="Închide">
            <CloseButtonLineOne />
            <CloseButtonLineTwo />
          </CloseButtonWrapper>
        </Header>
        <ModalContent>
          {GROUPS.map(group => {
            const menus = TEST_MENUS.filter(x => x.source === group.source)

            return (
              <Group key={group.source}>
                <GroupTitle>
                  {group.title} <span>· {menus.length}</span>
                </GroupTitle>
                {menus.map(menu => (
                  <Row
                    key={menu.slug}
                    href={`${process.env.REACT_APP_MENU_BASE_URL}/${menu.slug}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="text">
                      <span className="name">
                        {menu.name}
                        {menu.hasDarkTheme && <Tag>temă închisă</Tag>}
                      </span>
                      <span className="meta">{describeMenu(menu)}</span>
                    </div>
                    <span className="slug">/{menu.slug}</span>
                    <FontAwesomeIcon className="open-icon" icon={faExternalLink} />
                  </Row>
                ))}
              </Group>
            )
          })}
        </ModalContent>
      </Modal>
    </>
  )
}

function describeMenu(menu: TestMenu) {
  const parts = [`${menu.categories} categorii`, `${menu.products} produse`]

  if (menu.sections >= 2) {
    parts.push(`${menu.sections} secțiuni`)
  }

  parts.push(describePhotos(menu.photoPercent))

  return parts.join(' · ')
}

function describePhotos(percent: number) {
  if (percent === 0) {
    return 'fără poze'
  }

  if (percent >= 90) {
    return 'aproape toate cu poze'
  }

  if (percent < 35) {
    return 'puține poze'
  }

  return `${percent}% cu poze`
}
